import { StyleSheet, Text, View } from '@react-pdf/renderer'
import { Image } from '@ulysses-inc/harami_api_client'
import React from 'react'
import notFoundImage from 'src/assets/images/imageNotFound1000x1000.png'
import Grid from 'src/features/reports/result/downloadPDF/Grid'
import ReactPDFImage from 'src/features/reports/result/downloadPDF/ReactPDFImage'

const styles = StyleSheet.create({
  images: {
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    flexDirection: 'row',
  },
  imageColumn: {
    margin: 10,
    flexDirection: 'column',
  },
  image: {
    height: 300,
    width: 300,
  },
  optionManualMemo: {
    width: '100%',
  },
})

interface OwnProps {
  memo: Image
}

const OptionManualMemo: React.FC<OwnProps> = (props: OwnProps) => {
  return (
    <Grid style={styles.optionManualMemo}>
      <View>
        <Text>レポート手書きメモ</Text>
        <View key={props.memo.id} style={styles.imageColumn}>
          <ReactPDFImage
            style={styles.image}
            uri={
              props.memo?.url !== undefined
                ? `${props.memo?.url ?? ''}`
                : notFoundImage
            }
          />
        </View>
      </View>
    </Grid>
  )
}

export default OptionManualMemo
